import BaseAPIService from '../base/base-api-service';
import EcheckPermissionModel from 'src/model/echeckPermission.model';
import env from 'src/shared/env';

class EcheckPermissionService extends BaseAPIService<EcheckPermissionModel> {
  public baseURL: string = env.REACT_APP_BASE_API_URL;
  public endpoint: string = '/accountapp/v1/echeck';

  constructor() {
    super(EcheckPermissionModel);
  }

  public fetchEcheckDisabledUsers(): Promise<EcheckPermissionModel[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      url: `${this.endpoint}/disabledEcheckUsers`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  }

  public changeUserEcheckStatus(
    usernameArray: string[],
    status: boolean
  ): Promise<any> {  
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'PUT',
      params: {
        isECheckOptionEnabled: status,
      },
      data: usernameArray ,
      url: `${this.endpoint}/updateEcheckPermission`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

}

const echeckPermissionServiceInstance = new EcheckPermissionService();
Object.freeze(echeckPermissionServiceInstance);

export default echeckPermissionServiceInstance;
